import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "components";
import { getPINSegmentsService } from "services/admin/productService";
import { Grid } from "@mui/material";
import { errorAlert } from "helpers/alerts";
import { createBagPINSegmentsService, deleteBagPINSegmentsService } from "services/client/bagService";
import { setPINSegments } from "redux/slices/admin/productSlice";
import { setPINSegments as setBagPINSegments } from "redux/slices/client/bagSlice";
import { Box } from "@mui/system";

const BagPINSegmentScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'PDS');
  const { pinSegments: bagPINSegments } = useSelector((store) => store.bags);
  const { pinSegments } = useSelector((state) => state.products);

  useEffect(() => {
    getPINSegmentsService()
      .then((data) => dispatch(setPINSegments(data)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async ({ id }, currentValue) => {
    (currentValue ?
      deleteBagPINSegmentsService(currentBag.id, id) :
      createBagPINSegmentsService(currentBag.id, id)
    ).then((result) => {
      dispatch(setBagPINSegments(result));
    }).catch(error => errorAlert(error))
  };

  return (
    <>
      <Box mt={2} />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="commerce">Segmentos</div>
        </div>
        <div>
        </div>
      </Grid>
      <TableData
        dataRows={pinSegments.map((item) => {
          const find = bagPINSegments.find(({ idSegment }) => idSegment.id === item.id);
          return { ...item, state: find ? true : false };
        })}
        dataTitle={["Logo", "Nombre", "Estado"]}
        formatter={({ name, state, fd }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          { name: "state", type: "boolean", value: state },
        ]}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default BagPINSegmentScreen;
